"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var ToggleSwitch_1 = require("./ToggleSwitch");
var ToggleLabel_1 = require("./ToggleLabel");
var Toggle = function (_a) {
    var className = _a.className, label = _a.label, helperText = _a.helperText, _b = _a.status, status = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'left' : _c, isDisabled = _a.isDisabled, onToggle = _a.onToggle;
    var getToggleClasses = function () {
        return (0, classnames_1.default)('squid-p-2', 'squid-flex', 'squid-justify-center', {
            'squid-flex-row': variant === 'right',
            'squid-flex-row-reverse': variant === 'left',
        }, className);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: getToggleClasses() }, { children: [(0, jsx_runtime_1.jsx)(ToggleSwitch_1.ToggleSwitch, { status: status, onToggle: onToggle, isDisabled: isDisabled }), (0, jsx_runtime_1.jsx)(ToggleLabel_1.ToggleLabel, { variant: variant, label: label, isDisabled: isDisabled, helperText: helperText })] })));
};
exports.Toggle = Toggle;
